import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const input = this._input()
    input.addEventListener("input", this._mask)
    input.addEventListener("keydown", this._onKeydown)
    input.addEventListener("focus", this._ensurePrefix)
    if (input.value) this._apply(input)
  }

  disconnect() {
    const input = this._input()
    input.removeEventListener("input", this._mask)
    input.removeEventListener("keydown", this._onKeydown)
    input.removeEventListener("focus", this._ensurePrefix)
  }

  _ensurePrefix = (e) => {
    if (!e.target.value) e.target.value = "+"
  }

  _onKeydown = (e) => {
    if (e.key === "Backspace") {
      const input = e.target
      const pos = input.selectionStart
      const val = input.value
      // If cursor is right after a non-digit char (like - or ) or space), skip it
      if (pos > 0 && /[^0-9+]/.test(val[pos - 1])) {
        e.preventDefault()
        // Find the previous digit and remove it
        let newPos = pos - 1
        while (newPos > 0 && /[^0-9]/.test(val[newPos - 1])) newPos--
        if (newPos > 0) {
          const raw = val.slice(0, newPos - 1) + val.slice(newPos)
          input.value = raw
          this._apply(input)
          // Set cursor
          const formatted = input.value
          const targetPos = Math.max(newPos - 1, 1)
          input.setSelectionRange(targetPos, targetPos)
        }
      }
    }
  }

  _mask = (e) => {
    const input = e.target
    const pos = input.selectionStart
    const oldLen = input.value.length
    this._apply(input)
    const newLen = input.value.length
    const newPos = Math.max(pos + (newLen - oldLen), 1)
    input.setSelectionRange(newPos, newPos)
  }

  _apply(input) {
    let raw = input.value.replace(/[^\d+]/g, "")
    if (!raw.startsWith("+")) raw = "+" + raw

    let digits = raw.replace(/\D/g, "")
    digits = digits.slice(0, 13)

    if (digits.length === 0) {
      input.value = "+"
      return
    }

    if (digits.startsWith("55") && digits.length > 2) {
      const ddi = digits.slice(0, 2)
      const rest = digits.slice(2)

      if (rest.length > 6) {
        input.value = `+${ddi} (${rest.slice(0, 2)}) ${rest.slice(2, 7)}-${rest.slice(7)}`
      } else if (rest.length > 2) {
        input.value = `+${ddi} (${rest.slice(0, 2)}) ${rest.slice(2)}`
      } else if (rest.length > 0) {
        input.value = `+${ddi} (${rest}`
      } else {
        input.value = `+${ddi}`
      }
    } else {
      if (digits.length <= 3) {
        input.value = `+${digits}`
      } else {
        input.value = `+${digits.slice(0, 3)} ${digits.slice(3)}`
      }
    }
  }

  _input() {
    return this.element.tagName === "INPUT" ? this.element : this.element.querySelector("input")
  }
}
